/*
 * 配置编译环境和线上环境之间的切换
 * baseUrl: 域名地址
 * routerMode: 路由模式
 */
let baseTitle = ''; //标题
let Repairphone = '';  //报修电话
let baseUrl = '';
let routerMode = 'history';
let DEBUG = false;
let ApiUrl = '';
let authUrl = '';
let app_id = '';
let app_secret = '';
let cancleHTTP = []; //取消请求头设置；
DEBUG = false;

/**------北区--------**/
// baseTitle = '北区供热';
// Repairphone = '029-33560857';
// // baseUrl = "http://192.168.2.220:8800/tms/";
// baseUrl = "http://weixin.xybqgr.com:8800/tms/";
// authUrl = "http://weixin.xybqgr.com/"; //本地域名
// ApiUrl = "http://weixin.xybqgr.com:8800/file";
// app_id = 'wx139b46d9d9d8ff35';
// app_secret = '15a0b14348bfd7ebfdab48ab23f6edf0';
// bqCompanyId = 'D4v1pQBEqaNlLe7wj9Ld9knJgZP5oARy83W'

// app_id = 'wx66f73f9258562eb3';
// app_secret = '64b51100da1fdae3b5992eb748ad817b';

/**-------新北方--------**/
baseTitle = '新北方热力';
baseUrl = "http://www.xinbfqj.com:8800/tms/"; // 新北方
authUrl = "http://www.xinbfqj.com/"; //// 新北方
ApiUrl = "http://www.xinbfqj.com:8800/file"; // 新北方
app_id = 'wx3a7b87da9455ff78'; // 新北方
app_secret = '1e5bc9ac6ad9216043b6a1df233978be'; // 新北方

module.exports = {
	baseTitle,
	baseUrl,
	ApiUrl,
	authUrl,
	app_id,
	app_secret,
	routerMode,
	DEBUG,
	cancleHTTP
}



// WEBPACK FOOTER //
// ./src/common/js/env.js